import { checkErrorResponse, errorHandler } from '@/components/utils/ai-data-source-generator';
import { svgAiLibrary } from '@/service/svg-ai-library';

export function getAiToolbar(e, options) {
  const
    dxButtonNames = ['exportButton', 'groupPanel', 'columnChooserButton'],
    dxButtons = e.toolbarOptions.items.filter(button => dxButtonNames.includes(button.name)),
    buttons = {},
    defaultItem = {
      refresh: {
        index: 2,
        icon: svgAiLibrary['ai-refresh-base'],
        text: 'Обновить',
      },
      check: {
        index: 3,
        icon: svgAiLibrary['ai-choose-base'],
        text: 'Выбрать',
        disabled: true,
      },
      expand: {
        index: 4,
        icon: svgAiLibrary['ai-expand-or-collapse-base'],
        text: 'Развернуть все',
      },
      copy: {
        index: 5,
        icon: svgAiLibrary['ai-copy-base'],
        text: 'Копировать',
        disabled: true,
      },
      add: {
        index: 6,
        icon: svgAiLibrary['ai-add-base'],
        text: 'Добавить',
      },
      addRoot: {
        index: 7,
        icon: svgAiLibrary['ai-add-base'],
        text: 'Добавить',
      },
      addChild: {
        index: 8,
        icon: svgAiLibrary['ai-add-child-base'],
        text: 'Добавить дочерний',
      },
      delete: {
        index: 9,
        icon: svgAiLibrary['ai-delete-base'],
        text: 'Удалить',
        disabled: true,
      },
      save: {
        index: 10,
        icon: svgAiLibrary['ai-save-base'],
        text: 'Сохранить',
        disabled: true,
      },
      undo: {
        index: 11,
        icon: svgAiLibrary['ai-revert-base'],
        text: 'Отменить',
        disabled: true,
      },
    };
  let items = [...dxButtons];

  for (const [key, value] of Object.entries(options)) {
    if (defaultItem[key]) {
      items.push({
        name: `ai${key}Button`,
        location: 'after',
        widget: 'dxButton',
        locateInMenu: 'auto',
        showText: 'inMenu',
        sortIndex: defaultItem[key].index,
        cssClass: 'toolbar-item-custom-style',
        options: {
          disabled: options[key].disabled || !!defaultItem[key].disabled,
          icon: defaultItem[key].icon,
          hint: defaultItem[key].text,
          text: defaultItem[key].text,
          onClick: value.event,
          onInitialized: ({ component }) => {
            buttons[key] = component;
            buttons.clicked = false;
          },
        },
      });
    }
  }

  items = items.sort((a, b) => a.sortIndex < b.sortIndex && -1 || 1);

  options.customs?.forEach(template => {
    const neighbor = template.before || template.after;
    if (!template.locateInMenu)
      template.locateInMenu = 'auto';
    if (neighbor) {
      const element = items.find(item => item.name === neighbor || item.name === `ai${neighbor}Button`);
      if (element)
        items.splice((items.indexOf(element)) + (template.after && 1 || 0), 0, template);
    } else {
      items.push(template);
    }
  });

  const columnChooserButton = items.find(x => x.name === 'columnChooserButton');

  if (columnChooserButton) {
    columnChooserButton.cssClass = 'toolbar-item-custom-style';
    columnChooserButton.options.icon = svgAiLibrary['ai-show-column-chooser-base']
  }

  const exportButton = items.find(x => x.name === 'exportButton');

  if (exportButton) {
    exportButton.cssClass = 'toolbar-item-dropdown-custom-style';
    exportButton.options.icon = svgAiLibrary['ai-export-group-base']
  }

  e.toolbarOptions.items = items;

  return buttons;
}

export const checkHasEditData = (instance, buttons) => {
  const disabled = !instance.hasEditData();
  if (buttons.save) {
    buttons.save.option({ disabled });
    buttons.save.clicked = false;
  }
  if (buttons.undo) {
    buttons.undo.option({ disabled });
  }

  return disabled;
};

export const undoEditData = (instance, ds) => {
  instance.cancelEditData();

  if (ds) ds.reload();
};

export const getRawEditingData = (instance) => {
  return instance.option('editing.changes');
};

export const getGroupedEditingData = async (instance, options = {}) => {
  const
    fields = ['insert', 'update', 'remove'],
    result = {},
    changes = instance.option('editing.changes');

  const keys = changes.map(item => item.key);
  if (keys.length) {
    const sourceDataArray = await instance.getDataByKeys([keys]);
      fields.map(type => {
        const changesByType = changes.filter(item => item.type === type);
        result[type] = (changesByType.map(item => {
          let changedData = item.data;

          if (options.full) {
            const sourceData = sourceDataArray[0].filter(x => x.key === item.key)[0];
            changedData = { ...sourceData, ...changedData };
          }
          return { ...changedData };
        }));
      });

    if (options.simple) {
      const changesRows = [];
      fields.forEach(type => {
        changesRows.push(...(result[type].map(x => {
          x.statusRow = type[0];
          return x;
        })));
      });
      return changesRows;
    } else {
      return result;
    }
  }
};

export const loadingState = (instance, begin = true) => {
  const method = `${begin && 'begin' || 'end'}CustomLoading`;
  instance[method]();
};

export const saveFullData = async ({ saveButton, dxInstance, saveFn, params, reloadDataFn }) => {
  try {
    if (saveButton) saveButton.clicked = true;
    if (dxInstance) loadingState(dxInstance);
    if (saveFn) {
      const data = await saveFn(params);
      checkErrorResponse(data);
    }
    if (reloadDataFn) reloadDataFn();
  } catch (e) {
    errorHandler(e);
  } finally {
    if (dxInstance) loadingState(dxInstance, false);
  }
};


